import { TFormatted } from '@ws/shared/types';

import { readTitle } from './titleContent';

/**
 * Узлы, которые попадают в документ, даже если текста в них нет: разделитель сцены
 * и заглушки отложенных картинок с таблицами. Коллекция из одних разделителей —
 * тощий, но не пустой документ, и отказывать в экспорте ей неправильно.
 */
const STRUCTURAL = 'hr, img, table';

function rendersSomething(html: string): boolean {
  if ((html ?? '').trim() === '') {
    return false;
  }

  const { body } = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html');

  return (body.textContent ?? '').trim() !== '' || body.querySelector(STRUCTURAL) !== null;
}

/**
 * Есть ли что класть в документ.
 *
 * Критерий намеренно совпадает с тем, по которому решают сборщики: заголовок читается
 * тем же `readTitle`, а «видимость» содержимого — тем же признаком. Пока предикаты
 * расходились, находились входы, где страж пропускал экспорт, а на выходе оказывался
 * пустой файл — ровно то, ради чего страж и существует.
 */
export function hasRenderableContent(entities: TFormatted[]): boolean {
  return entities.some(
    (entity) =>
      rendersSomething(entity.originalContent ?? '') ||
      (entity.withTitle && readTitle(entity.name ?? '').text !== ''),
  );
}
